if (!customElements.get('hc-instagram')) {
  class HcInstagram extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.isDown = false;
      this.startX = 0;
      this.scrollStart = 0;
      this.hasMoved = false;
      this.DRAG_MULTIPLIER = 1.5;

      this.onMouseDown = this.onMouseDown.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-js="instagram-track"]');
      if (!this.track) return;

      this.track.addEventListener('mousedown', this.onMouseDown);
      this.track.addEventListener('mousemove', this.onMouseMove);
      this.track.addEventListener('mouseup', this.onMouseUp);
      this.track.addEventListener('mouseleave', this.onMouseUp);
      this.track.addEventListener('click', this.onClick, true);

      document.addEventListener('shopify:section:load', this.onSectionLoad);

      if (this.dataset.beholdId) {
        this.fetchBehold();
      }
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('mousedown', this.onMouseDown);
        this.track.removeEventListener('mousemove', this.onMouseMove);
        this.track.removeEventListener('mouseup', this.onMouseUp);
        this.track.removeEventListener('mouseleave', this.onMouseUp);
        this.track.removeEventListener('click', this.onClick, true);
        this.track = null;
      }
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }

    onSectionLoad(e) {
      if (e && e.detail && e.detail.sectionId === this.dataset.sectionId) {
        if (this.dataset.beholdId) {
          this.fetchBehold();
        }
      }
    }

    onMouseDown(e) {
      this.isDown = true;
      this.hasMoved = false;
      this.startX = e.pageX;
      this.scrollStart = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      var dx = e.pageX - this.startX;
      if (Math.abs(dx) > 3) this.hasMoved = true;
      this.track.scrollLeft = this.scrollStart - dx * this.DRAG_MULTIPLIER;
    }

    onMouseUp() {
      if (!this.isDown) return;
      this.isDown = false;
      if (this.track) {
        this.track.classList.remove('is-dragging');
      }
    }

    onClick(e) {
      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    async fetchBehold() {
      var feedId = this.dataset.beholdId;
      if (!feedId) return;

      try {
        var res = await fetch('https://feeds.behold.so/' + feedId);
        if (!res.ok) throw new Error('Behold: ' + res.status);
        var data = await res.json();
        this.renderBeholdCards(data);
      } catch (err) {
        console.warn('[hc-instagram] Behold fetch failed:', err.message);
        this.removeSkeleton();
      }
    }

    removeSkeleton() {
      if (!this.track) return;
      var skeletons = this.track.querySelectorAll('.hc-instagram__card.is-skeleton');
      skeletons.forEach(function (el) { el.remove(); });
    }

    renderBeholdCards(data) {
      if (!this.track) return;

      var posts = [];
      var feedUsername = this.dataset.defaultUsername || 'afroyla';

      if (data && Array.isArray(data.posts)) {
        posts = data.posts;
        if (data.username) feedUsername = data.username;
      } else if (Array.isArray(data)) {
        posts = data;
      }

      var count = parseInt(this.dataset.postCount || '6', 10);
      posts = posts.slice(0, count);

      if (posts.length === 0) {
        this.removeSkeleton();
        return;
      }

      var defaultAvatar = this.dataset.defaultAvatar || '';
      var self = this;

      this.removeSkeleton();

      posts.forEach(function (post) {
        var mediaUrl = '';
        if (post.sizes && post.sizes.medium && post.sizes.medium.mediaUrl) {
          mediaUrl = post.sizes.medium.mediaUrl;
        } else if (post.sizes && post.sizes.large && post.sizes.large.mediaUrl) {
          mediaUrl = post.sizes.large.mediaUrl;
        } else if (post.mediaUrl) {
          mediaUrl = post.mediaUrl;
        } else if (post.media_url) {
          mediaUrl = post.media_url;
        }

        var permalink = post.permalink || '#';
        var caption = post.caption || '';
        var truncatedCaption = caption.length > 80 ? caption.substring(0, 80) + '...' : caption;
        var timeAgo = self.getRelativeTime(post.timestamp);
        var likesText = post.like_count ? self.formatLikes(post.like_count) : '';

        var avatarHtml = defaultAvatar
          ? '<img class="hc-instagram__avatar" src="' + self.esc(defaultAvatar) + '" alt="" width="36" height="36" loading="lazy" draggable="false">'
          : '<div class="hc-instagram__avatar hc-instagram__avatar--placeholder"></div>';

        var card = document.createElement('article');
        card.className = 'hc-instagram__card';
        card.innerHTML =
          '<div class="hc-instagram__card-inner">' +
            '<div class="hc-instagram__card-header">' +
              '<div class="hc-instagram__user">' +
                avatarHtml +
                '<span class="hc-instagram__username">' + self.esc(feedUsername) + '</span>' +
              '</div>' +
              '<span class="hc-instagram__more-btn" aria-hidden="true">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="4" cy="10" r="1.5" fill="currentColor"/><circle cx="10" cy="10" r="1.5" fill="currentColor"/><circle cx="16" cy="10" r="1.5" fill="currentColor"/></svg>' +
              '</span>' +
            '</div>' +
            '<div class="hc-instagram__media">' +
              '<a href="' + self.esc(permalink) + '" target="_blank" rel="noopener noreferrer" class="hc-instagram__link" aria-label="View post by ' + self.esc(feedUsername) + ' on Instagram">' +
                '<img class="hc-instagram__image" src="' + self.esc(mediaUrl) + '" alt="Instagram post" loading="lazy" draggable="false">' +
              '</a>' +
            '</div>' +
            '<div class="hc-instagram__body">' +
              '<div class="hc-instagram__actions" aria-hidden="true">' +
                '<div class="hc-instagram__actions-left">' +
                  '<span class="hc-instagram__action-icon"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span>' +
                  '<span class="hc-instagram__action-icon"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>' +
                  '<span class="hc-instagram__action-icon"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></span>' +
                '</div>' +
                '<span class="hc-instagram__bookmark-icon"><svg width="15" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></span>' +
              '</div>' +
              '<div class="hc-instagram__content">' +
                (likesText ? '<p class="hc-instagram__likes">' + self.esc(likesText) + '</p>' : '') +
                (caption ? '<p class="hc-instagram__caption"><span class="hc-instagram__caption-user">' + self.esc(feedUsername) + '</span> ' + self.esc(truncatedCaption) + '<span class="hc-instagram__caption-more">more</span></p>' : '') +
                '<time class="hc-instagram__time">' + self.esc(timeAgo) + '</time>' +
              '</div>' +
              '<div class="hc-instagram__comment-bar" aria-hidden="true">' +
                '<div class="hc-instagram__comment-input">' +
                  '<span class="hc-instagram__smiley"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg></span>' +
                  '<span class="hc-instagram__comment-placeholder">Add a comment...</span>' +
                '</div>' +
                '<span class="hc-instagram__post-btn">Post</span>' +
              '</div>' +
            '</div>' +
          '</div>';

        self.track.appendChild(card);
      });
    }

    getRelativeTime(timestamp) {
      if (!timestamp) return '';
      var now = Date.now();
      var then = new Date(timestamp).getTime();
      var diffMs = now - then;
      if (diffMs < 0) return 'Just now';

      var minutes = Math.floor(diffMs / 60000);
      var hours = Math.floor(diffMs / 3600000);
      var days = Math.floor(diffMs / 86400000);
      var weeks = Math.floor(days / 7);

      if (minutes < 1) return 'Just now';
      if (minutes < 60) return minutes + (minutes === 1 ? ' minute ago' : ' minutes ago');
      if (hours < 24) return hours + (hours === 1 ? ' hour ago' : ' hours ago');
      if (days < 7) return days + (days === 1 ? ' day ago' : ' days ago');
      if (weeks < 52) return weeks + (weeks === 1 ? ' week ago' : ' weeks ago');
      return new Date(timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }

    formatLikes(count) {
      if (typeof count !== 'number') return '';
      if (count >= 1000000) return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M likes';
      if (count >= 1000) return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K likes';
      return count.toLocaleString() + ' likes';
    }

    esc(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(String(str)));
      return div.innerHTML;
    }
  }

  customElements.define('hc-instagram', HcInstagram);
}
